<template>
  <div v-if="props.visible" :class="overlayClass">
    <div class="overlay-content border rounded">
      <ProgressSpinner style="height: 2rem" stroke-width="8" fill="transparent" :aria-label="message" />
      <div class="loader-message">{{  props.message  }}</div>
    </div>
  </div>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { computed } from 'vue';

// Components
import ProgressSpinner from 'primevue/progressspinner';

// Composables

// Stores

// Constants and Utils

// ===============================
// PROPS & EMITS
// ===============================
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
    required: true,
  },
  message: {
    type: String,
    default: 'Loading...'
  },
  showOverlay: {
    type: Boolean,
    default: true
  } 
});

// ===============================
// COMPOSABLES & STORES
// ===============================

// ===============================
// REACTIVE STATE
// ===============================

// ===============================
// CONSTANTS
// ===============================

// ===============================
// COMPUTED PROPERTIES
// ===============================
const overlayClass = computed(() => {
  return props.showOverlay ? 'overlay' : 'loader';
});

// ===============================
// METHODS
// ===============================

// ===============================
// WATCHERS
// ===============================

// ===============================
// LIFECYCLE HOOKS
// ===============================

// ===============================
// EXPOSE
// ===============================

</script>

<style scoped>
.loader {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999 !important;
  padding: 3rem;
  border-radius: 1rem;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999 !important;
}

.overlay-content {
  display: flex;
  background-color: white;
  align-items: center;
  padding: 1rem;
  z-index: 1000000 !important;
}

.loader-message {
  margin-left: .25rem; /* Space between spinner and message */
}
</style>